module.exports = __webpack_public_path__ + "static/emulation-emulation-d509c40165b96dc2fc22652d9d84b05b.png";